var settings = require('ofs/settings');
var URI = require('URIjs')

var data = {
    headerFooterContactUs: {
        'value' : 15.53,
        'label' : 'huq4CJ_KgggQgeuO1gM',
        'guid' : 'ON',
        'script' : 0,
    },
    searchResultPage: {
        'value' : 15.53,
        'label' : '8g6QCJfLgggQgeuO1gM',
        'guid' : 'ON',
        'script' : 0,
    },
    homeListingPage: {
        'value' : 26.40,
        'label' : '_p_MCP_NgggQgeuO1gM',
        'guid' : 'ON',
        'script' : 0,
    },
    homeListingAvailabilityEnquiry: {
        'value' : 16.00,
        'label' : 'OsQrCI_MgggQgeuO1gM',
        'guid' : 'ON',
        'script' : 0,
    },
    checkoutPages: {
        'value' : 40.00,
        'label' : 'A0eqCIfUgwgQgeuO1gM',
        'guid' : 'ON',
        'script' : 0,
    }
};

var sourceMap = {
    "header enquiry": data.headerFooterContactUs,
    "responsive enquire home availability": data.homeListingPage,
    "responsive ask a question": data.homeListingPage,
    "enquire home availability": data.homeListingAvailabilityEnquiry,
    "enquire booking checkout": data.checkoutPages,
    "enquire booking": data.headerFooterContactUs,
    "enquire home": data.homeListingPage,
    "enquire home property": data.homeListingPage,
    "ask a question": data.homeListingPage,
    "search enquiry": data.searchResultPage,
    "footer enquiry": data.headerFooterContactUs,
    "payment method telephone": data.checkoutPages
};

var trackGoogleAdwords = function(source) {
    var adwordsData = sourceMap[source];
    if (settings.tracking.gactive && settings.tracking.googleAdwordsTracking && typeof adwordsData !== 'undefined') {
        var src = new URI("https://www.googleadservices.com/pagead/conversion/985904513/");
        src.search(adwordsData);
        var img = document.createElement("img");
        img.src = src.toString();
        img.width = 1;
        img.height = 1;
        img.style.position = "absolute";
        img.style.visibility = "hidden";
        document.body.appendChild(img);
    } else {
        console.log('Google adwords pixel tracking disabled', source, adwordsData);
    }
};

module.exports = trackGoogleAdwords;


/** WEBPACK FOOTER **
 ** ./static/js/onefinestay/apps/core/utils/tracking/adwords.js
 **/